import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {VideoGridElement} from '../../_shared/videos-grid/video-grid-element.model';


@Component({
    selector: 'app-adu',
    templateUrl: './adu.component.html',
    styleUrls: ['./adu.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AduComponent {

  id: number;

  videos: VideoGridElement[] = [
    {
      url: 'https://www.youtube.com/embed/epqN7dEYDvQ?list=PL99qj8Q3_1psopvHemZMeUntqzEw7-m5a',
      title: 'Presentation 1: ADUs with Jennifer Budzak',
      powerpoint: null
    },
    {
      url: 'https://www.youtube.com/embed/06uofHAZ8qU',
      title: 'ASSESSOR’S ADU RESOURCE SEMINAR',
      powerpoint: null
    }
  ];

  constructor(private actRoute: ActivatedRoute) {
    this.id = this.actRoute.snapshot.params.id;
  }

}
